/**
 * Agent health and status thresholds
 */
export const AGENT_THRESHOLDS = {
  /** Minutes since last seen to consider agent online */
  ONLINE_MINUTES: 5,

  /** Minimum disk space required on Windows (GB) */
  MIN_DISK_SPACE_WINDOWS: 150,

  /** Minimum disk space required on macOS/Linux (GB) */
  MIN_DISK_SPACE_UNIX: 60,

  /** Minimum RAM required on Windows (GB) */
  MIN_RAM_WINDOWS: 16,

  /** Minimum RAM required on macOS/Linux (GB) */
  MIN_RAM_UNIX: 6,
} as const;

/**
 * Task status values
 */
export const TASK_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
} as const;

/**
 * Tunnel status values
 */
export const TUNNEL_STATUS = {
  CONFIGURED: 'configured',
  NOT_CONFIGURED: 'not_configured',
  PENDING: 'pending',
} as const;
